export default __webpack_public_path__ + "static/media/banner.db7bb217.png";